import React, { useState, useRef, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import SplashText from '../SplashText';
import Button from '../Button';
import FullPageIframe from './FullPageIframe';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import VideoPlayerMenu from './VideoPlayerMenu';
import { usePxToVw } from '../../../../hooks/usePxToVw';
import WheelchairToggle from '../../../WheelchairToggle';
import WeatherWidget from '../../../WeatherWidget';

const SubMenuPage = ({
  menu,
  clicked,
  handleTextClick,
  uploadedUrls,
  handleFinalAction,
  splashText,
  settings,
  backToMenu,
  videotime,
  menuContent,
  externalweblink,
  subMenuSettings,
  numColumns,
  columnSpacing,
  enableOffset,
  leftOffset,
  topOffset,
  isSecondView,
  isthirdView,
  brandColor,
  resetSession,
  changeVideoFun,
  handleSubTopicTextClick,
  brandFont,
  rightOffset,
  lineHeight,
  padding,
  fontSize,
  removeWhiteFlashOnVideo,
  disableAnimation = false,
  menuPopup,
  redirectAttactLoop,
  captionSettings,

  setIsCaptionOn,

  isCaptionOn,

  enableVideoEndOffset,
  videoEndTopOffset,
  videoEndLeftOffset,
  videoEndRightOffset,
  handleWayfinderButtonClick = null, // New prop for wayfinder handling (with default)
  disableAreYouTherePopup = false, // New prop to control popup
  enableNextNavigation = false, // New prop for next navigation
  handleNextNavigation = null, // New prop for next navigation handler
  globalSettings,
  nextButtonFileUrl: nextButtonFileUrlProp, // Fallback for next button URL from parent
  selectedLanguage,
  availableLanguages = [],
  onLanguageChange,
  getLanguageName,
  getLanguageFlag,

  toggleState,
  currentState = false,
  enableInvisibleToggleButton = false,

  wheelchairSettings = { enabled: false },
  wheelchairContentOffsetY = 20,
  clientUrl,
  weatherSettings = { enabled: false },
  isWheelchairMode = false, // NEW: Receive from parent
  onWheelchairToggle, // NEW: Receive handler from parent

  // Video End Navigation props
  enableVideoEndNavigation,
  videoEndNavigationMenuId,
  primaryMenu,
  primarySubMenu,
  subhandleTextClick,

  subMenuVideoEndNavigation
}) => {
  const { pxToVw, getMaxWidth } = usePxToVw();

  console.log("enableNext Navigation", enableNextNavigation)

  const [showVideoEndMenu, setShowVideoEndMenu] = useState(false);

  const videoRef = useRef(null);
  const [playCount, setPlayCount] = useState(0);
  const [videoComplete, setVideoComplete] = useState(false);
  const [editOpen, setEditOpen] = useState(false);
  const [isAvailable, setIsAvailable] = useState(false);

  const [countdown, setCountdown] = useState(5);

  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  // Helper function to handle button clicks with wayfinder support
  const handleButtonClick = async item => {
    // Check if this is a wayfinder button and handler is available
    if (item?.linkedWayfinder && item?.linkedWayfinder?.status && handleWayfinderButtonClick) {

      // Check for direct location navigation
      if (
        item.linkedWayfinder.directLocation?.status &&
        item.linkedWayfinder.directLocation?.location
      ) {
        console.log('Direct location navigation:', item.linkedWayfinder.directLocation.location);

        // Navigate directly to avatar screen for the specified location
        const wayfinderHandled = await handleWayfinderButtonClick({
          ...item,
          directLocationId: item.linkedWayfinder.directLocation.location,
          isDirectLocation: true,
          navigationType: 'directLocation',
        });

        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }

      // Check for search page navigation
      else if (item.linkedWayfinder.searchPage?.status) {

        // Navigate to search screen with location data
        const wayfinderHandled = await handleWayfinderButtonClick({
          ...item,
          navigationType: 'searchPage',
          isSearchPage: true,
        });

        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }

      // Handle other wayfinder navigation types (categories, subcategories, locations)
      else {
        const wayfinderHandled = await handleWayfinderButtonClick(item);
        if (wayfinderHandled) {
          return; // Exit early if wayfinder handled the click
        }
      }
    } else if (
      item?.linkedWayfinder &&
      item?.linkedWayfinder?.status &&
      !handleWayfinderButtonClick
    ) {
      console.error('Wayfinder button clicked but handleWayfinderButtonClick is not available!');
      console.error('This prop must be passed from the parent component.');
    }

    // Original button click logic for non-wayfinder buttons
    if (!item?.linkedTrivia) {
      handleTextClick(item?.id, item?.linkbtnId);
    } else {
      handleSubTopicTextClick(item?.id, item?.linkedTrivia);
    }
  };

  useEffect(() => {
    if (editOpen && countdown > 0) {
      const timer = setInterval(() => {
        setCountdown(prev => prev - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup function
    } else if (countdown === 0) {
      handleCountdownComplete();
    }
  }, [editOpen, countdown]);

  const handleCountdownComplete = () => {
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src'); // Unset the video source first
      videoRef.current.load(); // Forces the video to unload
    }
    // Close the dialog after countdown
    resetSession();
  };

  const modalClodeFun = () => {
    //setIsSecondView();

    setPlayCount(0);
    setVideoComplete(false);
    setEditOpen(false);
    setCountdown(5);
    setIsAvailable(true);

    if (!enableVideoEndOffset.current && !showVideoEndMenu) {
      changeVideoFun();
      if (videoRef.current) {
        videoRef.current.pause(); // Pause in case it was playing
        videoRef.current.currentTime = 0;
        // Ensure video is loaded before playing
        videoRef.current.load(); // Reload video to apply source changes
        videoRef.current.onloadeddata = () => {
          videoRef.current.play();
        };
      } else {
        console.log('videoRef.current is null');
        return;
      }
    } else {
      setTimeout(() => {
        if (currentState === true && enableInvisibleToggleButton) {
          setEditOpen(true);
        } else if (currentState === false && enableInvisibleToggleButton) {
          setEditOpen(false);
        } else {
          setEditOpen(true);
        }
      }, 30000);
    }
    // setShowVideoEndMenu(false);
  };


  const handleAnimationComplete = index => {
    if (index === 0) {
      handleFinalAction();
      setPlayCount(0);
      setVideoComplete(false);
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.currentTime = 0;
      }
    }
  };

  const handleVideoPlayPage = () => {
    const videoElement = videoRef.current;
    if (videoElement) {
      videoElement.muted = false;
    }
  };

  // const handleVideoEnd = () => {
  //   if (videotime === 0) {
  //     videoRef.current.play();
  //   } else if (playCount < videotime - 1) {
  //     setPlayCount((prevCount) => prevCount + 1);
  //     videoRef.current.play();
  //   } else {
  //     if (videoRef.current) {
  //       videoRef.current.pause();
  //       videoRef.current.currentTime = videoRef.current.duration - 0.5;
  //     }
  //     if (menu.length === 0) {
  //       setVideoComplete(true);
  //       if (videoRef?.current) {
  //         videoRef.current.pause();
  //         videoRef.current.removeAttribute("src"); // Unset the video source first
  //         videoRef.current.load(); // Forces the video to unload
  //       }

  //       setIsCaptionOn(false);

  //       if (redirectAttactLoop) {
  //         resetSession();
  //       } else {
  //         backToMenu();
  //       }
  //     } else {
  //       // Check if popup is disabled
  //       if (disableAreYouTherePopup) {
  //         // Don't show popup, just pause on last frame and stay there
  //         console.log('Are You There popup is disabled - staying on last frame');
  //         return;
  //       }

  //       if (enableVideoEndOffset.current) {
  //         setShowVideoEndMenu(true);
  //       }
  //       if (enableVideoEndOffset.current) {
  //         setTimeout(() => {
  //           setEditOpen(true);
  //         }, 30000);

  //       } else {
  //         setEditOpen(true);
  //       }
  //     }
  //   }
  // };

  const handleVideoEnd = () => {
    if (videotime === 0) {
      videoRef.current.play();
    } else if (playCount < videotime - 1) {
      setPlayCount((prevCount) => prevCount + 1);
      videoRef.current.play();
    } else {
      // Always pause on last frame when video completes
      if (videoRef.current) {
        videoRef.current.pause();
        // Set to last frame (slightly before end to avoid black screen)
        if (disableAreYouTherePopup) {
          videoRef.current.currentTime = videoRef.current.duration - 1;
        }
      }

      if (menu.length === 0) {
        if (
          disableAreYouTherePopup ||
          (currentState === false && enableInvisibleToggleButton)
        ) {
          // Don't show popup, just stay paused on last frame
          console.log('Are You There popup is disabled - staying on last frame');
          return;
        }
        setVideoComplete(true);
        if (videoRef?.current) {
          videoRef.current.pause();
          videoRef.current.removeAttribute("src"); // Unset the video source first
          videoRef.current.load(); // Forces the video to unload
        }

        setIsCaptionOn(false);

        if (redirectAttactLoop) {
          resetSession();
        } else {
          backToMenu();
        }
      } else {
        // Check if video end navigation is enabled
        if (enableVideoEndNavigation?.current && videoEndNavigationMenuId?.current) {

          // Find the menu to navigate to
          const targetMenuId = videoEndNavigationMenuId.current;

          // Check if it's "main_menu" - navigate to main menu (screenSteps 2)
          if (targetMenuId === 'main_menu') {
            console.log('Navigating to Main Menu (screenSteps 2)');
            if (videoRef?.current) {
              videoRef.current.pause();
              videoRef.current.removeAttribute('src');
              videoRef.current.load();
            }

            subMenuVideoEndNavigation()
            return;
          } else {
            // Check if it's a primary menu
            const primaryMenuItem = primaryMenu?.find(m => m.id === targetMenuId);
            if (primaryMenuItem) {
              // Call handleTextClick with the menu ID and linkbtnId
              handleTextClick(primaryMenuItem.id, targetMenuId);
              return;
            }

            // Check if it's a submenu
            const submenuItem = primarySubMenu?.find(s => s.id === targetMenuId);
      

            if (submenuItem) {
              if (subhandleTextClick) {
                subhandleTextClick(submenuItem.id, submenuItem.linkbtnId);
              } else {
                handleTextClick(submenuItem.id, submenuItem.linkbtnId);
              }
              return;
            }
            console.warn('Target menu not found:', targetMenuId);
            console.warn('Available menus:', { primaryMenu, primarySubMenu });
          }




        }

        // Check if popup is disabled
        if (disableAreYouTherePopup) {
          // Don't show popup, just stay paused on last frame
          console.log('Are You There popup is disabled - staying on last frame');
          return;
        }

        // Show popup if enabled
        if (enableVideoEndOffset.current) {
          setShowVideoEndMenu(true);
        }

        if (enableVideoEndOffset.current) {
          setTimeout(() => {
            if (currentState === true && enableInvisibleToggleButton) {
              setEditOpen(true);
            } else if (currentState === false && enableInvisibleToggleButton) {
              setEditOpen(false);
            } else {
              setEditOpen(true);
            }
          }, 30000);
        } else {
          if (currentState === true && enableInvisibleToggleButton) {
            setEditOpen(true);
          } else if (currentState === false && enableInvisibleToggleButton) {
            setEditOpen(false);
          } else {
            setEditOpen(true);
          }
        }
      }
    }
  };




  const backToMenufun = async () => {
    setPlayCount(0);
    setVideoComplete(false);
    setIsAvailable(false);
    if (videoRef?.current) {
      videoRef.current.pause();
      videoRef.current.removeAttribute('src'); // Unset the video source first
      videoRef.current.load(); // Forces the video to unload
    }
    // Always go back to the submenu/menu - never use previous navigation on back button
    backToMenu();
  };

  // const backToMenufun = async () => {
  //   setPlayCount(0);
  //   setVideoComplete(false);
  //   setIsAvailable(false);
  //   if (videoRef?.current) {
  //     videoRef.current.pause();
  //     videoRef.current.removeAttribute('src');
  //     videoRef.current.load();
  //   }
  //   // Always go back to the submenu/menu — never use previous navigation on back button
  //   backToMenu();
  // };

  useEffect(() => {
    if (clicked && disableAnimation) {
      handleFinalAction();
    }
  }, [clicked]);

  const handleAnimationCompleteDisabledAnimation = () => {
    setPlayCount(0);
    setVideoComplete(false);
    if (videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  };

  const renderButtons = () => {
    if (numColumns === 'center-single-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleTextClick(item?.id, item?.linkbtnId);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleTextClick(item?.id, item?.linkbtnId),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
              // onClick={() => handleTextClick(item?.id, item?.linkbtnId)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: item.side === 'left' ? '-100vw' : '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-left-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'unlimited-right-buttons-center') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: `${pxToVw(columnSpacing)}`,
            // width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, type: clicked ? 'slideOut' : 'visible' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: index * 0.2,
                    },
                  }),
                  slideOut: custom => ({
                    x: '100vw',
                    opacity: 1,
                    transition: {
                      type: 'spring',
                      damping: 15,
                      stiffness: 100,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.2,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
                style={{ width: 'unset !Important' }}

              // onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'center-two-buttons-per-row') {
      const leftButtons = (menu || []).filter(item => item.side === 'left');
      const rightButtons = (menu || []).filter(item => item.side === 'right');

      return (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {/* Left Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(columnSpacing)}`,
              width: '100%',
            }}
          >
            {leftButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                  onClick: () => {
                    handleButtonClick(item);
                    handleAnimationCompleteDisabledAnimation();
                  },
                }
                : {
                  custom: { index, direction: 'left' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '-100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    slideOut: custom => ({
                      x: '-100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (leftButtons.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },
                  // className="text-item"
                  //onClick={() => handleButtonClick(item)}

                  onClick: () => handleButtonClick(item),
                };
              return (
                <ButtonWrapper
                  key={index}
                  {...animationProps}
                  className="text-item"
                //    onClick={() => handleButtonClick(item)}
                >
                  <Button
                    key={index}
                    text={item?.name}
                    settings={item?.settings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>

          {/* Right Column */}
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              gap: `${pxToVw(columnSpacing)}`,
              width: '100%',
            }}
          >
            {rightButtons.map((item, index) => {
              const ButtonWrapper = disableAnimation ? 'div' : motion.div;
              const animationProps = disableAnimation
                ? {
                  onClick: () => {
                    handleButtonClick(item);
                    handleAnimationCompleteDisabledAnimation();
                  },
                }
                : {
                  custom: { index, direction: 'right' },
                  initial: 'hidden',
                  animate: clicked ? 'slideOut' : 'visible',
                  variants: {
                    hidden: custom => ({
                      x: '100vw',
                      opacity: 1,
                      scale: 0.95,
                      transition: {
                        type: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    visible: custom => ({
                      x: 0,
                      opacity: 1,
                      scale: 1,
                      transition: {
                        ease: 'easeInOut',
                        damping: 30,
                        duration: 1,
                        stiffness: 20,
                        delay: custom.index * 0.15,
                      },
                    }),
                    slideOut: custom => ({
                      x: '100vw',
                      opacity: 0,
                      scale: 0.95,
                      transition: {
                        ease: 'easeInOut',
                        duration: 1,
                        delay: 1 + (rightButtons.length - 1 - custom.index) * 0.15,
                      },
                    }),
                  },
                  // className="text-item"
                  onClick: () => handleButtonClick(item),
                  onAnimationComplete: definition => {
                    if (definition === 'slideOut') {
                      handleAnimationComplete(index);
                    }
                  },
                };
              return (
                <ButtonWrapper
                  key={index}
                  {...animationProps}
                  className="text-item"
                //    onClick={() => handleButtonClick(item)}
                >
                  <Button
                    key={index}
                    text={item?.name}
                    settings={item?.settings}
                    keyid={item?.id}
                  />
                </ButtonWrapper>
              );
            })}
          </div>
        </div>
      );
    } else if (numColumns === 'right-side-one-button-per-row') {
      const sortedMenu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {sortedMenu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index, direction: 'right' },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                variants: {
                  hidden: custom => ({
                    x: '100vw',
                    opacity: 1,
                    scale: 0.95,
                    transition: {
                      type: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.15,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    transition: {
                      ease: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.1,
                    },
                  }),
                  slideOut: custom => ({
                    x: '100vw',
                    opacity: 0,
                    scale: 0.95,
                    transition: {
                      ease: 'easeInOut',
                      duration: 1,
                      delay: 1 + (sortedMenu.length - 1 - custom.index) * 0.15,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
              //    onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    } else if (numColumns === 'left-side-one-button-per-row') {
      const sortedMenuu = [...(menu || [])].sort((a, b) => a.order - b.order);

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: `${pxToVw(columnSpacing)}`,
            width: '100%',
          }}
        >
          {sortedMenuu.map((item, index) => {
            const ButtonWrapper = disableAnimation ? 'div' : motion.div;
            const animationProps = disableAnimation
              ? {
                onClick: () => {
                  handleButtonClick(item);
                  handleAnimationCompleteDisabledAnimation();
                },
              }
              : {
                custom: { index },
                initial: 'hidden',
                animate: clicked ? 'slideOut' : 'visible',
                exit: 'slideOut', // Ensures exit animation is applied
                variants: {
                  hidden: custom => ({
                    x: '-100vw',
                    opacity: 1,
                    scale: 0.95,
                    transition: {
                      type: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.15,
                    },
                  }),
                  visible: custom => ({
                    x: 0,
                    opacity: 1,
                    scale: 1,
                    transition: {
                      ease: 'easeInOut',
                      damping: 30,
                      duration: 1,
                      stiffness: 20,
                      delay: custom.index * 0.1,
                    },
                  }),
                  slideOut: custom => ({
                    x: '-100vw',
                    opacity: 0,
                    scale: 0.95,
                    transition: {
                      ease: 'easeInOut',
                      duration: 1,
                      delay: 1 + (sortedMenuu.length - 1 - custom.index) * 0.15,
                    },
                  }),
                },
                // className="text-item"
                onClick: () => handleButtonClick(item),
                onAnimationComplete: definition => {
                  if (definition === 'slideOut') {
                    handleAnimationComplete(index);
                  }
                },
              };
            return (
              <ButtonWrapper
                key={index}
                {...animationProps}
                className="text-item"
              //    onClick={() => handleButtonClick(item)}
              >
                <Button key={index} text={item?.name} settings={item?.settings} keyid={item?.id} />
              </ButtonWrapper>
            );
          })}
        </div>
      );
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Responsive padding calculation
  const getResponsivePadding = () => {
    if (windowSize.width < 768) return '8px';
    if (windowSize.width < 1200) return '12px';
    return '15px';
  };

  // Responsive margin calculation
  const getResponsiveMargin = () => {
    if (windowSize.width < 768) return '10px';
    if (windowSize.width < 1200) return '15px';
    return '20px';
  };

  // Responsive logo size calculation
  const getResponsiveLogoSize = baseSize => {
    if (windowSize.width < 480) return Math.min(baseSize, 80);
    if (windowSize.width < 768) return Math.min(baseSize, 100);
    if (windowSize.width < 1200) return Math.min(baseSize, 120);
    return Math.min(baseSize, 150);
  };

  const motionProps = removeWhiteFlashOnVideo
    ? {}
    : {
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 },
      transition: { duration: 2 },
    };

  // Check if there are any videos available
  const hasVideos = () => {
    return (
      (uploadedUrls?.splashVideo?.fileUrl && uploadedUrls?.splashVideo?.enabled) ||
      (uploadedUrls?.splashVideotwo?.fileUrl && uploadedUrls?.splashVideotwo?.enabled) ||
      (uploadedUrls?.splashVideothree?.fileUrl && uploadedUrls?.splashVideothree?.enabled)
    );
  };

  // Effect for menu popup when no videos are present
  useEffect(() => {
    let popupInterval;

    // Don't set up popup if it's disabled
    if (disableAreYouTherePopup) {
      return;
    }

    if (menuPopup && menuPopup > 0 && !hasVideos() && menuContent !== 'weblink') {
      // Convert menuPopup seconds to milliseconds
      const intervalTime = menuPopup * 1000;

      popupInterval = setInterval(() => {
        if (currentState === true && enableInvisibleToggleButton) {
          setEditOpen(true);
        } else if (currentState === false && enableInvisibleToggleButton) {
          setEditOpen(false);
        } else {
          setEditOpen(true);
        }
        //setCountdown(5); // Reset countdown each time popup opens
      }, intervalTime);

      console.log(`Menu popup interval set for ${menuPopup} seconds`);
    }

    // Cleanup interval on component unmount or when dependencies change
    return () => {
      if (popupInterval) {
        clearInterval(popupInterval);
      }
    };
  }, [menuPopup, uploadedUrls]); // Re-run when menuPopup, uploadedUrls, or disableAreYouTherePopup change

  // Toggle play/pause on invisible click area
  const handleInvisiblePlayPause = () => {
    const video = videoRef.current;
    if (!video) return;

    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }
  };

  return (
    <div className="">
      <div
        onClick={handleInvisiblePlayPause}
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '200px',
          cursor: 'pointer',
          background: 'transparent',
          zIndex: 9999, // make sure it's above video
        }}
      />

      {/* First Video */}
      {(menuContent === 'video' && !isSecondView && !isthirdView) ||
        (menuContent === 'video' && isSecondView && !uploadedUrls?.splashVideotwo?.enabled) ||
        (menuContent === 'video' && isthirdView && !uploadedUrls?.splashVideothree?.enabled) ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={`${uploadedUrls?.splashVideo?.fileUrl}_${selectedLanguage}`}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
            captionFileUrl={uploadedUrls.splashVideo && uploadedUrls?.splashVideo?.captionFile}
          />
        </AnimatePresence>
      ) : (
        ''
      )}

      {/* Second Video */}

      {menuContent === 'video' && isSecondView && uploadedUrls?.splashVideotwo?.enabled ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={`${uploadedUrls?.splashVideotwo?.fileUrl}_${selectedLanguage}`}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
            captionFileUrl={
              uploadedUrls.splashVideotwo && uploadedUrls?.splashVideotwo?.captionFile
            }
          />
        </AnimatePresence>
      ) : (
        ''
      )}

      {/* Third Video */}

      {menuContent === 'video' && isthirdView && uploadedUrls?.splashVideothree?.enabled ? (
        <AnimatePresence mode="wait">
          <VideoPlayerMenu
            videoRef={videoRef}
            videoKey={`${uploadedUrls?.splashVideothree?.fileUrl}_${selectedLanguage}`}
            handleVideoPlayPage={handleVideoPlayPage}
            handleVideoEnd={handleVideoEnd}
            removeWhiteFlashOnVideo={removeWhiteFlashOnVideo}
            captionSettings={captionSettings}
            setIsCaptionOn={setIsCaptionOn}
            isCaptionOn={isCaptionOn}
            captionFileUrl={
              uploadedUrls.splashVideothree && uploadedUrls?.splashVideothree?.captionFile
            }
          />
        </AnimatePresence>
      ) : (
        ''
      )}

      {menuContent === 'weblink' && (
        <AnimatePresence mode="wait">
          <motion.div
            //className="video-container"
            {...motionProps}
          >
            <FullPageIframe
              url={externalweblink}
              onTimeout={() => backToMenu()}
              brandColor={brandColor}
              brandFont={brandFont}
              menuPopup={menuPopup}
            />
          </motion.div>
        </AnimatePresence>
      )}

      <div className="corner-overlays-responsive">
        {/* Top Left Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item top-left"
            style={{
              ...(uploadedUrls?.leftTop?.disabledPadding && { padding: 0 }),
              ...(uploadedUrls?.leftTop?.disabledMargin && { left: 0 }),
              ...(uploadedUrls?.leftTop?.disabledMargin && { top: 0 }),
              justifyContent: 'left',
            }}
          >
            <img
              src={uploadedUrls?.leftTop?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.leftTop?.enabled ? 'block' : 'none',

                //    width: uploadedUrls?.leftTop?.width > 0 ?
                //      `${pxToVw(uploadedUrls.leftTop.width)}` : 'auto',
                //    height: uploadedUrls?.leftTop?.height > 0 ?
                //      `${pxToVw(uploadedUrls.leftTop.height)}` : 'auto',
                maxWidth: `${uploadedUrls.leftTop.width > 0 ? '100vw' : getMaxWidth('25vw')}`,
                //  maxHeight: `${uploadedUrls.leftTop.height > 0 ? 'unset' : '25vw'}`,

                width: uploadedUrls?.leftTop?.width > 0 ? `${uploadedUrls.leftTop.width}%` : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>

        {/* Back Button */}
        <AnimatePresence mode="wait">
          <motion.div {...motionProps} className="corner-item back-button">
            <img
              src={uploadedUrls?.backMenuMedia?.fileUrl}
              alt="Back"
              style={{
                display: uploadedUrls?.backMenuMedia?.enabled ? 'block' : 'none',
                cursor: 'pointer',
                // maxWidth: uploadedUrls?.backMenuMedia?.width > 0 ? 'unset' : getMaxWidth('30vw'),
                // maxHeight: uploadedUrls?.backMenuMedia?.height > 0 ? 'unset' : getMaxWidth('30vw'),
                width:
                  uploadedUrls?.backMenuMedia?.width > 0
                    ? `${uploadedUrls.backMenuMedia.width}%`
                    : '100%',
                // height: "15vw"
              }}
              onClick={() => backToMenufun()}
            />
          </motion.div>
        </AnimatePresence>

        {/* Top Right Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item top-right"
            style={{ justifyContent: 'right' }}
          >
            <img
              src={uploadedUrls?.rightTop?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.rightTop?.enabled ? 'block' : 'none',
                //  width: uploadedUrls?.rightTop?.width > 0 ?
                //    `${pxToVw(uploadedUrls.rightTop.width)}` : 'auto',
                //  height: uploadedUrls?.rightTop?.height > 0 ?
                //    `${pxToVw(uploadedUrls.rightTop.height)}` : 'auto',
                maxWidth: `${uploadedUrls.rightTop.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                //  maxHeight: `${uploadedUrls.leftTop.height > 0 ? 'unset' : '25vw'}`,
                width:
                  uploadedUrls?.rightTop?.width > 0 ? `${uploadedUrls.rightTop.width}%` : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>

        {/* Bottom Right Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item bottom-right"
            style={{ justifyContent: 'right' }}
          >
            <img
              src={uploadedUrls?.rightBottom?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.rightBottom?.enabled ? 'block' : 'none',
                //  width: uploadedUrls?.rightBottom?.width > 0 ?
                //    `${pxToVw(uploadedUrls.rightBottom.width)}` : 'auto',
                //  height: uploadedUrls?.rightBottom?.height > 0 ?
                //    `${pxToVw(uploadedUrls.rightBottom.height)}` : 'auto',
                // maxWidth: '25vw',
                //  maxHeight: '25vw'

                maxWidth: `${uploadedUrls.rightBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                width:
                  uploadedUrls?.rightBottom?.width > 0
                    ? `${uploadedUrls.rightBottom.width}%`
                    : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>

        {/* Bottom Left Logo */}
        <AnimatePresence mode="wait">
          <motion.div
            {...motionProps}
            className="corner-item bottom-left"
            style={{ justifyContent: 'left' }}
          >
            <img
              src={uploadedUrls?.leftBottom?.fileUrl}
              alt="Logo"
              style={{
                display: uploadedUrls?.leftBottom?.enabled ? 'block' : 'none',
                //  width: uploadedUrls?.leftBottom?.width > 0 ?
                //    `${pxToVw(uploadedUrls.leftBottom.width)}` : 'auto',
                //  height: uploadedUrls?.leftBottom?.height > 0 ?
                //    `${pxToVw(uploadedUrls.leftBottom.height)}` : 'auto',
                //  maxWidth: '25vw',
                //  maxHeight: '25vw'
                maxWidth: `${uploadedUrls.leftBottom.width > 0 ? '100%' : getMaxWidth('25vw')}`,
                width:
                  uploadedUrls?.leftBottom?.width > 0
                    ? `${uploadedUrls.leftBottom.width}%`
                    : 'auto',
                height: 'auto',
              }}
            />
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Language Flag Selector - Horizontal Row */}
      {/* {availableLanguages && availableLanguages.length > 1 && (
        <div
          style={{
            position: 'absolute',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            zIndex: 1000,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            background: 'rgba(0, 0, 0, 0.6)',
            padding: '10px 20px',
            borderRadius: '50px',
            backdropFilter: 'blur(10px)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.4)',
            transition: 'all 0.3s ease',
          }}
        >
          {availableLanguages.map((lang) => (
            <button
              key={lang}
              onClick={() => {
                if (onLanguageChange) {
                  onLanguageChange(lang);
                }
              }}
              title={getLanguageName ? getLanguageName(lang) : lang.toUpperCase()}
              style={{
                background: selectedLanguage === lang
                  ? 'rgba(255, 255, 255, 0.3)'
                  : 'transparent',
                border: selectedLanguage === lang
                  ? '2px solid rgba(255, 255, 255, 0.8)'
                  : '2px solid transparent',
                borderRadius: '8px',
                padding: '6px',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: '48px',
                height: '36px',
                boxShadow: selectedLanguage === lang
                  ? '0 2px 8px rgba(255, 255, 255, 0.3)'
                  : 'none',
              }}
              onMouseEnter={(e) => {
                if (selectedLanguage !== lang) {
                  e.currentTarget.style.background = 'rgba(255, 255, 255, 0.15)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.4)';
                }
              }}
              onMouseLeave={(e) => {
                if (selectedLanguage !== lang) {
                  e.currentTarget.style.background = 'transparent';
                  e.currentTarget.style.borderColor = 'transparent';
                }
              }}
            >
              <img
                src={`https://flagcdn.com/32x24/${getLanguageFlag ? getLanguageFlag(lang) : lang}.png`}
                alt={`${getLanguageName ? getLanguageName(lang) : lang} flag`}
                style={{
                  width: '32px',
                  height: '24px',
                  borderRadius: '3px',
                  boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
                  objectFit: 'cover',
                }}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </button>
          ))}
        </div>
      )} */}

      {/* Wheelchair Toggle Button - Only show when there are menu buttons */}
      {menu && menu.length > 0 && (
        <WheelchairToggle
          settings={wheelchairSettings}
          isActive={isWheelchairMode}
          onClick={onWheelchairToggle}
        />
      )}

      {/* Weather Widget */}
      {weatherSettings?.enabled && weatherSettings?.visibility?.subMenu && (
        <div
          style={{
            position: 'absolute',
            top: weatherSettings.positionTop !== null && weatherSettings.positionTop !== undefined ? `${weatherSettings.positionTop}%` : 'auto',
            bottom: weatherSettings.positionBottom !== null && weatherSettings.positionBottom !== undefined ? `${weatherSettings.positionBottom}%` : 'auto',
            ...(weatherSettings.horizontalAlign === 'center'
              ? { left: '50%', right: 'auto', transform: 'translateX(-50%)' }
              : {
                left: weatherSettings.positionLeft !== null && weatherSettings.positionLeft !== undefined ? `${weatherSettings.positionLeft}%` : 'auto',
                right: weatherSettings.positionRight !== null && weatherSettings.positionRight !== undefined ? `${weatherSettings.positionRight}%` : 'auto',
              }
            ),
            zIndex: 1000,
          }}
        >
          <WeatherWidget
            apiKey={weatherSettings.weatherApiKey}
            latitude={weatherSettings.latitude}
            longitude={weatherSettings.longitude}
            forecastDays={weatherSettings.forecastDays || 3}
            temperatureUnit={weatherSettings.temperatureUnit || 'both'}
            celsiusFirst={weatherSettings.celsiusFirst !== false}
            showLocation={weatherSettings.showLocation || false}
            showClock={weatherSettings.showClock !== false}
            showCurrentWeather={weatherSettings.showCurrentWeather !== false}
            showForecast={weatherSettings.showForecast !== false}
            widgetOrder={weatherSettings.widgetOrder || ['clock', 'current', 'forecast']}
            backgroundColor={weatherSettings.backgroundColor || '#ffffff'}
            backgroundOpacity={weatherSettings.backgroundOpacity ?? 80}
            textColor={weatherSettings.textColor || '#1a202c'}
            subTextColor={weatherSettings.subTextColor || '#718096'}
            padding={weatherSettings.padding ?? 16}
            borderRadius={weatherSettings.borderRadius ?? 12}
            width={weatherSettings.width || 0}
            fontFamily={weatherSettings.fontFamily === 'inherit' || !weatherSettings.fontFamily ? brandFont || 'inherit' : weatherSettings.fontFamily}
            fontSize={weatherSettings.fontSize || 14}
            iconSize={weatherSettings.iconSize || 40}
            forecastIconSize={weatherSettings.forecastIconSize || 28}
            shadowH={weatherSettings.shadowH ?? 0}
            shadowV={weatherSettings.shadowV ?? 4}
            shadowBlur={weatherSettings.shadowBlur ?? 12}
            shadowSpread={weatherSettings.shadowSpread ?? 0}
            shadowColor={weatherSettings.shadowColor || '#000000'}
            shadowOpacity={weatherSettings.shadowOpacity ?? 15}
            useVwSizing={true}
          />
        </div>
      )}

      <motion.div
        className="responsive-menu-containerr"
        initial={false}
        animate={{
          top:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndTopOffset.current}%`
              : enableOffset
                ? `${topOffset + (isWheelchairMode ? wheelchairContentOffsetY : 0)}%`
                : (isWheelchairMode ? `${wheelchairContentOffsetY}%` : 0),

          left:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndLeftOffset.current > 0 ? videoEndLeftOffset.current + '%' : 'unset'}`
              : enableOffset
                ? `${leftOffset}%`
                : 0,

          right:
            showVideoEndMenu && enableVideoEndOffset?.current
              ? `${videoEndRightOffset.current > 0 ? videoEndRightOffset.current + '%' : 'unset'}`
              : enableOffset
                ? `${rightOffset}%`
                : 0,
        }}
        transition={{
          opacity: {
            times: [0, 0.3, 0.6, 1],
            duration: 1.2,
            ease: 'easeInOut',
          },
          top: {
            duration: 1.2,
            ease: 'easeInOut',
          },
          left: {
            duration: 1.2,
            ease: 'easeInOut',
          },
          right: {
            duration: 1.2,
            ease: 'easeInOut',
          },
        }}
        style={{
          position: menuContent === "weblink" ? "relative" : "absolute",
          width: enableOffset ? "auto" : "100%",
          height: enableOffset ? "auto" : "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
          padding: "2%",
          boxSizing: "border-box",
        }}
      >
        {/* Center Logo */}
        <AnimatePresence mode="wait">
          <motion.div {...motionProps} className="center-logo-container">
            <img
              src={uploadedUrls?.centerLogo?.fileUrl}
              alt="Logo"
              style={{
                marginBottom: getResponsiveMargin(),
                maxWidth: showVideoEndMenu && enableVideoEndOffset.current ? '50vw' : 'auto',
                display: uploadedUrls?.centerLogo?.enabled ? "block" : "none",
                // maxWidth: '35vw',
                // maxHeight: '35vw',
                // maxWidth: `${uploadedUrls.centerLogo.width > 0 ? 'unset' : '25vw'}`,
                width:
                  uploadedUrls?.centerLogo?.width > 0
                    ? `${uploadedUrls.centerLogo.width}%`
                    : "auto",
                height: "auto",

                maxWidth:
                  showVideoEndMenu && enableVideoEndOffset.current
                    ? "50vw"
                    : "auto",
              }}
            />
          </motion.div>
        </AnimatePresence>

        <div
          style={{
            display: "flex",
            flexDirection:
              numColumns === "center-single-row" ? "row" : "column",
            alignItems: "center",
            justifyContent: "center",
            // width: '100%',
            gap: getResponsivePadding(),
            flexWrap: "wrap",
            marginTop: "2vw",
            // gap: "20px" // Add gap between buttons
          }}
        >
          {renderButtons()}
        </div>

        <AnimatePresence mode="wait">
          <motion.div
            //className="video-container"
            {...motionProps}
          >
            <img
              src={uploadedUrls?.centerBelowMenuMedia?.fileUrl}
              alt="Logo"
              style={{
                marginTop: "30px",
                display: uploadedUrls?.centerBelowMenuMedia?.enabled
                  ? "block"
                  : "none",
                width:
                  uploadedUrls?.centerBelowMenuMedia?.width > 0
                    ? `${uploadedUrls.centerBelowMenuMedia.width}%`
                    : "auto",
                height: "auto",
                // maxHeight: "140px"
              }}
            />
          </motion.div>
        </AnimatePresence>
      </motion.div>

      <Dialog
        open={editOpen}
        onClose={modalClodeFun}
        sx={{
          '& .MuiDialog-paper': {
            backgroundColor: '#FFFFFF', // White modal background
            border: `2px solid ${brandColor}`,
            // padding: `${padding}px`,
            padding: `2vw`,
            borderRadius: '20px',
            width: '35vw',
            maxWidth: '70vw',
            // height:"auto"
            // marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`
          },
          '& .MuiBackdrop-root': {
            backgroundColor: 'transparent', // Change this to any color (Example: Red with opacity)
          },
          // "& .MuiDialog-container": {
          //  marginLeft:`${triviaQuizSettings?.quizsetting?.leftoffset}%`,
          //  justifyContent: "unset", // Remove justify-content
          // WebkitJustifyContent: "unset", // Remove -webkit-justify-content
          // },
        }}
      >
        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${fontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:lineHeight
          }}
        >
          Are You There?
        </DialogTitle>

        <DialogTitle
          style={{
            textAlign: 'center',
            // fontSize:`${fontSize}px`,
            fontSize: `3vw`,
            fontFamily: brandFont,
            // lineHeight:lineHeight
          }}
        >
          {countdown}
        </DialogTitle>
        <DialogActions>
          <button
            style={{
              margin: '0 auto',
              background: brandColor,
              fontFamily: brandFont,
              fontSize: `2vw`,
              height: 'auto',
              maxHeight: '10vw',
              padding: '0.5vw 1vw',
            }}
            onClick={modalClodeFun}
          >
            Yes
          </button>
        </DialogActions>
      </Dialog>

      {/* Next Navigation Button - Only on content pages when enabled for parent menu */}
      {enableNextNavigation &&
        (nextButtonFileUrlProp || globalSettings?.nextButtonFileUrl) &&
        (menuContent === 'video' || menuContent === 'weblink') &&
        (!menu || menu.length === 0) && (
          <AnimatePresence mode="wait">
            <motion.div
              className="corner-item next-button"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              style={{
                justifyContent: 'end'
              }}
              onClick={() => {
                if (handleNextNavigation) {
                  handleNextNavigation();
                } else {
                  console.error("handleNextNavigation prop not provided to SubMenuPage");
                }
              }}
            >
              <img
                src={nextButtonFileUrlProp || globalSettings?.nextButtonFileUrl}
                alt="Next"
                style={{
                  width: globalSettings.nextButtonWidth > 0
                    ? `${globalSettings.nextButtonWidth}%`
                    : "auto",
                  height: "auto",
                  maxWidth: "100%",
                }}
              />
            </motion.div>
          </AnimatePresence>
        )}
    </div>
  );
};

export default SubMenuPage;